/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';

import { AmplitudeAbstractService } from './amplitude.abstract.service';

@Injectable()
export class AmplitudeServerService extends AmplitudeAbstractService {
  init(): void {
    // amplitude.getInstance().init(environment.AMPLITUDE_API_KEY);
  }

  setItem(key: string, val: any): void {
    // const identify = new amplitude.Identify().set(key, val);
    // amplitude.getInstance().identify(identify);
  }

  setItems(list: Array<{ key: string; val: any }>): void {
    // let identify = new amplitude.Identify();
    // for (const item of list) {
    //   identify = identify.set(item.key, item.val);
    // }
    // amplitude.getInstance().identify(identify);
  }

  unsetItem(key: string): void {
    // const identify = new amplitude.Identify().unset(key);
    // amplitude.getInstance().identify(identify);
  }

  logEventWithTimestamp(name: string, data: any): void {
    // amplitude.getInstance().logEventWithTimestamp(name, data);
  }

  logEvent(
    name: string,
    data: Record<string, unknown>,
    onSuccess: () => void,
    onError: (message?: string) => void,
  ): void {}
}
